import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {DirectivesModule} from '@app/directives';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {TranslateModule} from '@ngx-translate/core';
import {ModalModule, TooltipModule} from "ngx-bootstrap";
import {CsComponentsModule} from "@app/shared/cs-components/cs-components.module";
import {EditColumnSidepanelModal} from "@app/shared/edit-column-sidepanel/edit-column-sidepanel.model";

@NgModule({
    declarations: [
        EditColumnSidepanelModal,
    ],
    exports: [
        EditColumnSidepanelModal,
    ],
    imports: [
        CommonModule,
        DirectivesModule,
        FormsModule,
        ReactiveFormsModule,
        TranslateModule,
        TooltipModule,
        CsComponentsModule,
        ModalModule
    ],
    entryComponents: []
})
export class EditColumnSidepanelModule {
}
